import { useToastStore } from '@modules/toast/store';

interface CopyToClipboardComposable {
  copyToClipboard(text: string): Promise<void>;
}

export default function useCopyToClipboard(): CopyToClipboardComposable {
  const { displayPresetToast } = useToastStore();

  async function copyToClipboard(text: string): Promise<void> {
    await navigator.clipboard.writeText(text);
    displayPresetToast('copied');
  }

  return {
    copyToClipboard,
  };
}
